import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Video from '../../containers/video';
import RelatedVideo from '../../containers/related-video';

const VideoBlock = props => <Video {...props} />;
VideoBlock.displayName = 'Video';

export default withDynamicComponents({
  componentWhitelist: [
    RelatedVideo,
  ],
  mapInputToOutput: [
    ['relatedVideo', 'relatedVideo'],
  ],
})(VideoBlock);



// WEBPACK FOOTER //
// ./src/blocks/video/index.jsx